import React, { useContext, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { IconButton } from '@fluentui/react/lib/Button';
import { Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { getGridLocalization, isNullUndefinedOrEmpty, showMessage } from "../../../common/Helpers";
import MessageBox from "../../../components/Common/Message/MessageBox";
import { __MessageTypes } from "../../../common/Dictionaries";
import MainAppContext from "../../../MainAppContext";
import MatrixToolbar from '../../../components/Products/sPrivilege/Matrix/MatrixToolbar';
import { applyFilters, executeScrollMovementToFixLockRowOnEditCell, handlerFilter, setterActionFired, useFilterActionComponentData } from '../../../common/Helpers/JqxGridFilter';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
import { useGetTiposNotaChecklistMaintainer } from '../../../hooks/services/sPay/useOfEdPPrepare';
import { deleteTipoNotaChecklistEP, getTiposNotaChecklistEP, setTipoNotaChecklistEP, updateTipoNotaChecklistEP } from '../../../services/sPay/edpConfig.service';

// Mantenedor del catálogo spay.edp_mensaje_tipo_checklist_pdf: cada fila es un tipo de nota que el
// panel "Notas checklist" (SidePanelViewEdPChecklistNotas.js) dibuja como control dinámico, sin
// cantidad fija. Mismo patrón (grilla editable inline) que Maintainers/ObligationCategory.
export default function ChecklistNotaTipo(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin || contextSite.securityProps.isAdmin)

    const gridRef = useRef();

    const [messageConfig, setMessageConfig] = useState({
        message: null,
        messageType: "",
        showMessage: false,
    });

    const [editingRows, setEditingRows] = useState([]);
    const [listTipos, setListTipos] = useState(null);
    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);

    useGetTiposNotaChecklistMaintainer(listTipos, setListTipos);

    useFilterActionComponentData(gridRef, messageConfig, "ChecklistNotaTipo");

    const validateObject = (object) => {
        let isValid = !isNullUndefinedOrEmpty(object.tipoChecklistPdfNemo);
        isValid = isValid ? !isNullUndefinedOrEmpty(object.tipoChecklistPdfCode) : isValid;
        isValid = isValid ? !isNullUndefinedOrEmpty(object.name) : isValid;

        return isValid;
    };

    const handlerAddNewRow = () => {
        const _lowerId = listTipos.length !== 0 ? listTipos.reduce((min, obj) => obj.id < min ? obj.id : min, listTipos[0].id) : 0;
        const lowerId = listTipos.length === 0 ? -1 : (_lowerId > 0 ? ((_lowerId * -1) - 1) : _lowerId - 1);

        const newRow = {
            id: lowerId,
            tipoChecklistPdfNemo: "",
            tipoChecklistPdfCode: "",
            name: "",
        };

        gridRef.current.beginupdate();
        gridRef.current.addrow(null, newRow, 'first');

        listTipos.unshift(newRow);
        setListTipos(listTipos);

        if (editingRows.length > 0 ? editingRows.find(x => x === lowerId) === undefined : true) {
            editingRows.push(lowerId)
            setEditingRows(editingRows);
        }

        gridRef.current.endupdate();
        gridRef.current.updatebounddata('rows');
        setterActionFired("ChecklistNotaTipo", 1)
    };

    const isValidFormControls = (list) => {
        let isValidForm = true;

        list.forEach(element => {
            if (!validateObject(element)) {
                isValidForm = false;
            }
        });

        return isValidForm;
    };

    const handlerSave = async (itemId) => {
        const item = gridRef.current.props.source.records.find(x => parseInt(x.id) === itemId);

        if (validateObject(item)) {
            if (itemId <= 0) {
                await setTipoNotaChecklistEP(item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))

                        listTipos.forEach(element => {
                            if (element.id === parseInt(item.id)) {
                                element.id = serviceResponse.data.data.id;
                            }
                        });

                        setListTipos(listTipos);
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                    setterActionFired("ChecklistNotaTipo", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("ChecklistNotaTipo", 1)
                });
            }
            else {
                updateTipoNotaChecklistEP(itemId, item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                    setterActionFired("ChecklistNotaTipo", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("ChecklistNotaTipo", 1)
                });
            }

            setShowRequiredGlobalMessage(false);
        }
        else {
            setShowRequiredGlobalMessage(true);
        }
    };

    const handlerDelete = async (itemId) => {
        if (itemId <= 0) {
            const newList = listTipos.filter(x => x.id !== itemId);
            setListTipos(newList)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            setterActionFired("ChecklistNotaTipo", 1)
        }
        else {
            await deleteTipoNotaChecklistEP(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    const newList = listTipos.filter(x => x.id !== itemId);
                    setListTipos(newList)
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("ChecklistNotaTipo", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("ChecklistNotaTipo", 1)
            });
        }
    };

    const handlerCancel = async (itemId) => {
        if (itemId === null) {
            const newList = listTipos.filter(x => x.id !== itemId);
            setListTipos(newList)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            setterActionFired("ChecklistNotaTipo", 1)
        }
        else {
            await getTiposNotaChecklistEP().then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    const item_original = serviceResponse.data.data.find(x => x.id === itemId);

                    if (item_original) {
                        listTipos.forEach(element => {
                            if (item_original.id === element.id) {
                                for (const property in item_original) {
                                    element[property] = item_original[property]
                                }
                            }
                        });
                    }

                    setListTipos(listTipos);
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("ChecklistNotaTipo", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("ChecklistNotaTipo", 1)
            });
        }
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const isEditing = editingRows.find(x => x === itemId);
        return <>
            {
                profileHasAccess &&
                <>
                    {isEditing ? (
                        <>
                            {
                                itemId <= 0 ? (
                                    <>
                                        <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                        <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                    </>
                                ) : (
                                    <>
                                        <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                        <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancelar" ariaLabel="Cancelar" onClick={() => fieldActionHandler(itemId, 'cancel')} />
                                        <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                    </>
                                )
                            }
                        </>
                    ) : (
                        <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                    )}
                </>
            }
        </>
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'save':
                handlerSave(itemId)
                break;
            case 'delete':
                handlerDelete(itemId)
                break;
            case 'cancel':
                handlerCancel(itemId)
                break;
            default:
                break;
        }
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listTipos[rowIndex.boundindex].id;
        }
        return listTipos[rowIndex]?.id;
    };

    const onCellvaluechanged = (e) => {
        listTipos[e.args.rowindex][e.args.datafield] = e.args.value

        const copia_listTipos = JSON.parse(JSON.stringify(listTipos));
        setListTipos(copia_listTipos);

        if (editingRows.find(x => x === listTipos[e.args.rowindex].id) === undefined) {
            editingRows.push(listTipos[e.args.rowindex].id)
        }

        setEditingRows(editingRows);
        applyFilters(gridRef, 'ChecklistNotaTipo', false);

        executeScrollMovementToFixLockRowOnEditCell(gridRef);
    };

    const cellRenderClassStyle = (row, columnfield, value) => {
        return value === '' ? 'jqx-custom-validation-red' : '';
    };

    const columns = [
        { index: null, text: 'ID', dataField: 'id', width: '0%', columntype: 'textbox', editable: false, hidden: true },
        { index: null, text: t('data-lang-lbl-actions'), dataField: 'acciones', width: '10%', pinned: true,
            createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
            initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
        },
        { index: 0, text: 'Nemo',   dataField: 'tipoChecklistPdfNemo', width: '20%', columntype: 'textbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value) },
        { index: 1, text: 'Código', dataField: 'tipoChecklistPdfCode', width: '20%', columntype: 'textbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value) },
        { index: 2, text: 'Nombre (texto en el PDF)', dataField: 'name', width: '50%', columntype: 'textbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value) },
    ]

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>Tipos de nota checklist EdP</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox
                        inputParam_Message={messageConfig.message}
                        inputParam_Display={messageConfig.showMessage}
                        inputParam_MessageType={messageConfig.messageType}
                        inputParam_SetterMessage={setMessageConfig}
                    />
                </Card.Footer>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                    {
                        listTipos !== null &&
                        <div className="align-items-center h-100">
                            <MatrixToolbar
                                inputParam_HandleSaveData={null}
                                inputParam_HandleUploadData={null}
                                inputParam_HandleExportData={null}
                                inputParam_HandleAddRow={handlerAddNewRow}
                                inputParam_Configuration={{
                                    buttons: {
                                        showRowButtons: profileHasAccess,
                                        showExportData: false,
                                        showAddMasiveData: false,
                                        showAddData: profileHasAccess,
                                        showDownloadTemplate: false,
                                        showSaveAllData: false,
                                        groupedButtons: profileHasAccess
                                    },
                                    handlers: {
                                        handlerSave: profileHasAccess ? handlerSave : null,
                                        handlerSaveAll: null,
                                        handlerDelete: profileHasAccess ? handlerDelete : null,
                                        handlerCancel: profileHasAccess ? handlerCancel : null,
                                    },
                                    auxiliarListCallbackOnAdd: null,
                                }}
                                inputParam_ExternalExportTemplates={[]}
                                inputParam_CustomOpenPanel={false}
                                showRequiredMessage={showRequiredGlobalMessage}
                            />
                            <JqxGrid
                                ref={gridRef}
                                altrows={true}
                                enabletooltips={true}
                                width={'100%'}
                                theme={'light'}
                                autoheight={true}
                                editable={true}
                                pageable={true}
                                sortable={true}
                                filterable={true}
                                showfilterrow={true}
                                localization={getGridLocalization(t)}
                                source={new jqx.dataAdapter({
                                    localData: listTipos,
                                    dataType: 'array',
                                    dataFields: [
                                        { name: 'id', type: 'number' },
                                        { name: 'tipoChecklistPdfNemo', type: 'string' },
                                        { name: 'tipoChecklistPdfCode', type: 'string' },
                                        { name: 'name', type: 'string' },
                                    ],
                                    id: 'id'
                                })}
                                columns={columns}
                                onCellvaluechanged={onCellvaluechanged}
                                onFilter={(event) => handlerFilter(event, 'ChecklistNotaTipo')}
                            />
                        </div>
                    }
                </Card.Body>
            </Card>
        </div>
    );
}
